export const noHeader: string[] = [
    '/edu/sys/login',
];
